module.exports = __webpack_public_path__ + "static/media/sentone_white.88dbce87.png";